export default __webpack_public_path__ + "static/media/product_9.9783845c.png";